import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=5b1e85a4&scoped=true&"
import script from "./DialogContent.vue?vue&type=script&lang=ts&"
export * from "./DialogContent.vue?vue&type=script&lang=ts&"
import style0 from "./DialogContent.vue?vue&type=style&index=0&id=5b1e85a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e85a4",
  null
  
)

export default component.exports